import { Link } from "react-router-dom";

import Button from "@mui/material/Button";

import "../App.css";

function ErrorPage() {
  return (
    <main>
      <h1>404 – Page Not Found</h1>
      <h2 className="centered">
        Fudopia isn’t utopia (yet), but the page you’re looking for definitely
        isn’t on the menu.
      </h2>
      <div className="button-wrapper">
        <Link to="/">
          <Button color="primary" variant="contained">
            Go Back to the homepage
          </Button>
        </Link>
      </div>
    </main>
  );
}

export default ErrorPage;
